import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MbNavigationService, NavigationNode } from '../../mb-navigation.service'
import { map } from 'rxjs/operators'
import { MbConstants } from '../../../../shared/mb-constants'
import { SelectedSubCategories } from '../mb-category-navigation.module'
import { BehaviorSubject, combineLatest } from 'rxjs'
import { WindowRef } from '@spartacus/core'

@Component({
  selector: 'mb-category-navigation-third-level',
  templateUrl: './mb-category-navigation-third-level.component.html',
  styleUrls: ['./mb-category-navigation-third-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MbCategoryNavigationThirdLevelComponent {

  @Output() closeEvent = new EventEmitter<Event>()

  @Input() set isSubCategorySelected (isSubCategorySelected: boolean | null) {
    this.isSubCategorySelected$.next(!!isSubCategorySelected)
  }

  @Input() set activeSubCategory (activeSubCategory: NavigationNode | undefined | null) {
    this.activeSubCategory$.next(activeSubCategory)
  }

  @Input() set selectedCategory (selectedCategory: NavigationNode | undefined | null) {
    this.selectedCategory$.next(selectedCategory)
  }

  @Input() set selectedSubCategories (selectedSubCategories: SelectedSubCategories | null) {
    this.selectedSubCategories$.next(selectedSubCategories)
  }

  @Input() set activeFilter (activeFilter: NavigationNode | undefined | null) {
    this.activeFilter$.next(activeFilter)
  }

  navigation$ = this.navigationService.navigation$
  isSubCategorySelected$ = new BehaviorSubject<boolean>(false)
  selectedCategory$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)
  selectedSubCategories$ = new BehaviorSubject<SelectedSubCategories | null>({})
  activeFilter$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)
  activeSubCategory$ = new BehaviorSubject<NavigationNode | undefined | null>(undefined)

  areTeasersVisible$ = this.activeSubCategory$.pipe(
    map(activeSubCategory => activeSubCategory?.teasers?.some(teaser => teaser.isVisible) ?? false))

  state$ = combineLatest([
    this.navigation$,
    this.isSubCategorySelected$,
    this.selectedCategory$,
    this.selectedSubCategories$,
    this.activeFilter$,
    this.activeSubCategory$,
    this.areTeasersVisible$
  ]).pipe(map(([navigation, isSubCategorySelected, selectedCategory, selectedSubCategories, activeFilter,
                 activeSubCategory, areTeasersVisible]) => ({
    navigation,
    isSubCategorySelected,
    selectedCategory,
    selectedSubCategories,
    activeFilter,
    activeSubCategory,
    areTeasersVisible
  } as MbCategoryNavigationThirdLevelState)))

  constructor (private navigationService: MbNavigationService,
               private winRef: WindowRef) {
  }

  isCurrentRoute (route: string | undefined): boolean {
    if (this.winRef.isBrowser() && this.winRef.nativeWindow && !!route) {
      const path = this.winRef.nativeWindow.location.pathname
      return path?.endsWith(route)
    }
    return false
  }

  readonly products = MbConstants.PRODUCTS
  readonly applications = MbConstants.APPLICATIONS
  readonly orange = MbConstants.CORPORATE_ORANGE
}

export interface MbCategoryNavigationThirdLevelState {
  navigation: NavigationNode[];
  isSubCategorySelected: boolean;
  selectedCategory: NavigationNode | undefined | null;
  selectedSubCategories: SelectedSubCategories | undefined | null;
  activeFilter: NavigationNode | undefined | null;
  activeSubCategory: NavigationNode | undefined | null;
  areTeasersVisible: boolean;
}
